// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unban-content p[data-v-2527bbb2] {\n  margin: 0 0 10px;\n  font-size: 14px;\n}\n.unban-content .tip[data-v-2527bbb2] {\n  color: #909399;\n  font-size: 12px;\n}\n.unban-content .reset-tip[data-v-2527bbb2] {\n  margin-top: 6px;\n}\n.text-muted[data-v-2527bbb2] {\n  color: #c0c4cc;\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
